import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

const AnimatedOverlayShowcase = ({ backgroundSrc, layers = [] }) => {
  const getInitial = (from) => {
    switch (from) {
      case 'left':
        return { opacity: 0, x: -40 };
      case 'right':
        return { opacity: 0, x: 40 };
      case 'top':
        return { opacity: 0, y: -40 };
      case 'bottom':
        return { opacity: 0, y: 40 };
      default:
        return { opacity: 0, y: 20 };
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      style={{
        position: 'relative',
        width: '100%',
        maxWidth: '700px',
        aspectRatio: '16 / 9',
        minHeight: '300px',
        borderRadius: 12,
        overflow: 'visible',
        boxShadow: '0 25px 50px -12px rgba(0,0,0,0.35)',
        backgroundColor: '#f0f0f0',
        backgroundImage: `url(${backgroundSrc})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {layers.map((layer, idx) => (
        <motion.img
          key={idx}
          src={layer.src}
          alt={layer.alt || `overlay-${idx + 1}`}
          initial={getInitial(layer.from)}
          animate={{
            opacity: 1,
            x: 0,
            y: 0,
            translateY: layer.float === false ? 0 : [0, -6, 0, 6, 0],
          }}
          transition={{
            duration: 0.7,
            ease: 'easeOut',
            delay: idx * 0.2,
            translateY: { duration: 6, repeat: Infinity, ease: 'easeInOut' },
          }}
          style={{
            position: 'absolute',
            pointerEvents: 'none',
            ...layer.style,
          }}
        />
      ))}
    </motion.div>
  );
};

AnimatedOverlayShowcase.propTypes = {
  backgroundSrc: PropTypes.string.isRequired,
  layers: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
      from: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
      float: PropTypes.bool,
      style: PropTypes.object,
    })
  ),
};

export default AnimatedOverlayShowcase;